module.exports = __webpack_public_path__ + "static/media/giftCardCover.320c86ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GiftCard/giftCardCover.png
// module id = 632
// module chunks = 0